export default "__VITE_ASSET__8U8CkD88__"